// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file ping.proto (package ping, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ping.proto.
 */
export const file_ping: GenFile = /*@__PURE__*/
  fileDesc("CgpwaW5nLnByb3RvEgRwaW5nIgYKBFBpbmdCIKoCHVBua2wuV2ViLlN0cmVhbXNTZXJ2aWNlLlBpbmdzYgZwcm90bzM");

/**
 * @generated from message ping.Ping
 */
export type Ping = Message<"ping.Ping"> & {
};

/**
 * Describes the message ping.Ping.
 * Use `create(PingSchema)` to create a new message.
 */
export const PingSchema: GenMessage<Ping> = /*@__PURE__*/
  messageDesc(file_ping, 0);

